// extracted by mini-css-extract-plugin
export default {"class_action":"class_action___sPhYe","consent_content":"consent_content___UY3uF","title":"title___X9RWR","btn_control":"btn_control___OHcjP"};